<template>
  <div class="o-transition-type-category">
    <m-form-input id="o-transition-type-category__form-input" class="o-transition-type-category__form-input">
      <a-text id="o-transition-type-category__a-text" class="o-transition-type-category__a-text">カテゴリ</a-text>
      <a-select-field
        v-if="transitionCategoryIdOptions.length > 0"
        id="add-transitionCategory-campaign"
        v-model="transitionCategoryIdChild"
        class="o-transition-type-category__transition-doc-category"
        :disabled="disabled"
        :options="transitionCategoryIdOptions"
        placeholder="カテゴリを選択"
      />
    </m-form-input>
  </div>
</template>

<script>
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 'o-transition-type-category',
  components: {
    MFormInput,
    ASelectField,
  },
  mixins: [customRequest],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    transitionId: {
      type: String,
      default: '',
    },
  },
  emits: ['update:transitionId'],
  data() {
    return {
      transitionCategoryIdChild: this.transitionId,
      transitionCategoryIdOptions: [],
    };
  },
  watch: {
    transitionCategoryIdChild(val) {
      if (val && this.transitionCategoryIdOptions.some(item => item.value === val)) {
        this.$emit('update:transitionId', val);
      }
    },
    transitionId(newVal) {
      this.transitionCategoryIdChild = newVal;
    },
  },
  async mounted() {
    await this.getCategoryData();
    this.$nextTick(() => {
      this.transitionCategoryIdChild = this.transitionId;
    });
  },
  methods: {
    async getCategoryData() {
      const res = await this.postRequest('/campaigns-category/get-list', { execUserID: this.execUserID });
      if (res.status === 'success') {
        const newOptions = this.transformToOptionData(res.data);
        if (this.transitionId && !newOptions.some(item => item.value === this.transitionId)) {
          const id = this.transitionId;
          const doc = await this.postRequest('/campaigns-category/get', { id });
          if (doc.status === 'success') {
            newOptions.unshift(this.getCurrentSelectedItem(id, doc));
          } else {
            this.showErrorModal(doc.message || messageContent.requireTry('カテゴリのデータ取得'));
          }
        }

        if (JSON.stringify(this.transitionCategoryIdOptions) !== JSON.stringify(newOptions)) {
          this.transitionCategoryIdOptions = newOptions;
        }
      } else {
        this.showErrorModal(res.message || messageContent.requireTry('カテゴリのデータ取得'));
      }
    },
    getCurrentSelectedItem(id, doc) {
      if (doc.data && doc.data.data) {
        const data = doc.data.data;
        const item = {
          value: id,
          label: `[現在選択] ${data.categoryName || id}`,
          data: data,
        };
        return item;
      } else {
        const item = {
          value: id,
          label: ``,
          data: null,
        };
        return item;
      }
    },
    transformToOptionData(dataArray) {
      const ret = [];
      for (const id in dataArray) {
        const categoryData = dataArray[id];
        ret.push({
          value: id,
          label: categoryData.categoryName,
          data: categoryData,
        });
      }
      ret.sort((a, b) => (a.data.sortOrder > b.data.sortOrder ? 1 : -1));
      return ret;
    },
  },
};
</script>